import { uploadFile } from '../../../../shared/helpers';

const SWATCH_SIZE = 256;

/**
 * Generate a solid-color PNG swatch and upload it. Returns the public URL of the uploaded swatch.
 * Used to feed RGB/Pantone color selections into the AI Studio pipeline as `colorImageUrl`.
 */
export async function generateColorSwatchUrl(hex: string): Promise<string> {
    const canvas = document.createElement('canvas');
    canvas.width = SWATCH_SIZE;
    canvas.height = SWATCH_SIZE;
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('Canvas 2D context not available');
    ctx.fillStyle = hex;
    ctx.fillRect(0, 0, SWATCH_SIZE, SWATCH_SIZE);

    const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, 'image/png'));
    if (!blob) throw new Error('Failed to generate color swatch blob');

    const safeHex = hex.replace('#', '').toLowerCase();
    const file = new File([blob], `swatch-${safeHex}.png`, { type: 'image/png' });
    return uploadFile(file);
}
